import { render, staticRenderFns } from "./PinConfiguration.vue?vue&type=template&id=0f31c36a&"
import script from "./PinConfiguration.vue?vue&type=script&lang=js&"
export * from "./PinConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./PinConfiguration.vue?vue&type=style&index=0&id=0f31c36a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports